import React from 'react';
import { Link } from 'react-router-dom';

export const PROMOS = [
  { type: 'financing', fr: ['Financement 2e et 3e chance', 'Évaluation gratuite, sans obligation. Découvrez ce que vous pouvez conduire.', 'Vérifier mes options'], en: ['2nd & 3rd Chance Financing', 'Free evaluation, no obligation. Find out what you can drive.', 'Check my options'], link: '/demander-un-pret-auto' },
  { type: 'eligibility', fr: ['Admissibilité en 30 secondes', 'Répondez à quelques questions et voyez vos options de financement.', 'Vérifier mon admissibilité'], en: ['Eligibility in 30 seconds', 'Answer a few questions and see your financing options.', 'Check my eligibility'], link: '/verifier-admissibilite' },
  { type: 'callback', fr: ['Un conseiller vous rappelle', 'Parlez à un expert en financement, sans attente.', 'Nous joindre'], en: ['An advisor calls you back', 'Talk to a financing expert, no waiting.', 'Contact us'], link: '/contact' },
];

const BG = {
  financing: 'bg-gradient-to-br from-[#1a5c3b] to-[#0f3d26]',
  eligibility: 'bg-gradient-to-br from-emerald-600 to-teal-700',
  callback: 'bg-gradient-to-br from-slate-700 to-slate-900',
};

export const FinancingPromo = ({ promo, en }) => {
  const [title, subtitle, cta] = en ? promo.en : promo.fr;
  return (
    <div className={`col-span-1 sm:col-span-2 ${BG[promo.type]} rounded-xl overflow-hidden text-white p-6 sm:p-8 flex flex-col justify-center items-center text-center min-h-[280px]`} data-testid={`inventory-promo-${promo.type}`}>
      <h3 className="font-black text-2xl sm:text-3xl md:text-4xl mb-3 uppercase tracking-wide leading-tight text-white">{title}</h3>
      <p className="text-white/80 text-base sm:text-lg mb-6 max-w-md">{subtitle}</p>
      <Link to={promo.link} className="bg-white text-slate-800 font-bold px-8 py-3 rounded-lg hover:bg-slate-100 transition-colors text-sm uppercase tracking-wide">
        {cta}
      </Link>
    </div>
  );
};
